import i18n from '@/i18n'
import videoJs from 'video.js'
videoJs.addLanguage('zh-CN', {
  Play: i18n.t('f996285100'),
  Replay: i18n.t('ed208c3846'),
  'Play Video': i18n.t('f996285100'),
  Pause: i18n.t('c96a46727b'),
  Mute: i18n.t('021ad16252'),
  Unmute: i18n.t('c5042be9e1'),
  Fullscreen: i18n.t('aaee2e3006'),
  'Non-Fullscreen': i18n.t('c1e237fdf1')
})
export default videoJs
